import type { Data } from '../../../types.tsx';
import type { Props } from '../types.tsx';
import fetchData from './fetch-data/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async ({ baseUrl, preferenceKey }: Props): Promise<Data> => {
	try {
		const result = await fetchData(baseUrl, preferenceKey);
		return {
			value: result,
		};
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		if (e.statusCode === 404) {
			return { value: undefined };
		}
		throw e;
	}
};
